var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider',{staticClass:"my-3"}),_c('h6',[_vm._v("Copyright Dom Barter | "+_vm._s(new Date().getFullYear()))]),_c('h6',[_vm._v("v1.0.1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }